import React from 'react';

import { Icon } from 'design-system-web';
import {
  FONT_AWESOME_DUOTONE,
  ICON_SET_FONTAWESOME,
} from 'lane-shared/helpers/constants/icons';

import {
  formatTargetDuePrimaryLabel,
  getTargetDueUiState,
  withTargetPrefix,
} from './targetDueCellFormatting';

import styles from './styles.scss';

export type TargetDueTimeCellProps = {
  /** GraphQL may supply an ISO string at runtime */
  dueAt: Date | string | undefined;
  targetMet: boolean | null | undefined;
  timeZone: string;
  /** For tests only */
  nowMs?: number;
};

export function TargetDueTimeCell({
  dueAt,
  targetMet,
  timeZone,
  nowMs = Date.now(),
}: TargetDueTimeCellProps) {
  if (!dueAt) {
    return null;
  }

  const state = getTargetDueUiState(dueAt, targetMet, nowMs);
  const label = formatTargetDuePrimaryLabel(dueAt, timeZone, nowMs);

  if (!label) {
    return null;
  }

  const displayText =
    state === 'future' ? withTargetPrefix(label) : label;

  const cellClassName = [
    styles.targetDueCell,
    state === 'met' ? styles.targetDueCellMet : '',
    state === 'past_due' ? styles.targetDueCellPastDue : '',
  ]
    .filter(Boolean)
    .join(' ');

  let iconName: 'calendar-check' | 'calendar-exclamation' | null = null;
  
  if (state === 'met') {
    iconName = 'calendar-check';
  } else if (state === 'past_due') {
    iconName = 'calendar-exclamation';
  }

  return (
    <span className={cellClassName}>
      {iconName ? (
        <Icon
          name={iconName}
          set={ICON_SET_FONTAWESOME}
          type={FONT_AWESOME_DUOTONE}
          className={styles.targetDueCellIcon}
        />
      ) : null}
      <span>{displayText}</span>
    </span>
  );
}
